const CONTROL_BUCKET = 'control';
const EXPERIMENT_BUCKET = 'experiment';
const TREATMENT_BUCKET = 'treatment';
const VARIANT_BUCKET = 'variant';

const IDENTIFIER_BCID = 'BrowserCookieId';
const IDENTIFIER_USERID = 'UserId';
const IDENTIFIER_VIN = 'VIN';

export { CONTROL_BUCKET, EXPERIMENT_BUCKET, TREATMENT_BUCKET, VARIANT_BUCKET, IDENTIFIER_BCID, IDENTIFIER_USERID, IDENTIFIER_VIN };
